// src/components/admin/StaffList.jsx
import React, { useState, useEffect } from 'react';
import {
  Table,
  Input,
  Button,
  Card,
  Avatar,
  Tag,
  Space,
  Statistic,
  Row,
  Col,
  Spin,
  message,
  Pagination,
  Tooltip
} from 'antd';
import {
  SearchOutlined,
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  CalendarOutlined,
  EyeOutlined,
  ReloadOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined
} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { getRequest } from '../../../Utils/AppApi';
import moment from 'moment';

const { Search } = Input;

function StaffList() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0
  });
  const [stats, setStats] = useState({
    totalStaff: 0,
    activeStaff: 0,
    totalVisitsToday: 0,
    avgVisitsPerStaff: 0
  });

  useEffect(() => {
    fetchStaffList();
    // fetchStats();
  }, [pagination.current, searchText]);

  const fetchStaffList = async () => {
    setLoading(true);
    try {
      const response = await getRequest(
        `/admin/staff/list?page=${pagination.current}&limit=${pagination.pageSize}&search=${searchText}`,
        history
      );
      if (response.success) {
        setStaffList(response.data.staff);
        setPagination({
          ...pagination,
          total: response.data.pagination.totalRecords
        });
      }
    } catch (error) {
      message.error('Failed to load staff list');
    } finally {
      setLoading(false);
    }
  };

  // const fetchStats = async () => {
  //   try {
  //     const response = await getRequest('/admin/staff/stats', history);
  //     if (response.success) {
  //       setStats(response.data);
  //     }
  //   } catch (error) {
  //     console.error('Failed to load stats', error);
  //   }
  // };

  const handleViewDetails = (record) => {
    history.push(`/admin/staff/${record._id}/visits`, {
      staffName: record.name,
      staffUsername: record.username
    });
  };

  const columns = [
    {
      title: 'Staff',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <Space>
          <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#C9262C' }} />
          <div>
            <div style={{ fontWeight: 'bold' }}>{text}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>{record.username}</div>
          </div>
        </Space>
      )
    },
    {
      title: 'Contact',
      key: 'contact',
      render: (_, record) => (
        <Space direction="vertical" size="small">
          <div><PhoneOutlined /> {record.mobile}</div>
          {/* <div><MailOutlined /> {record.email || 'N/A'}</div> */}
        </Space>
      )
    },
    {
      title: 'Visits',
      key: 'visits',
      align: 'center',
      render: (_, record) => (
        <Space size="large">
          <Statistic value={record.totalVisits} suffix="total" valueStyle={{ fontSize: '16px' }} />
          <Statistic value={record.todayVisits} suffix="today" valueStyle={{ fontSize: '16px', color: '#C9262C' }} />
        </Space>
      )
    },
    {
      title: 'Last Visit',
      dataIndex: 'lastVisitDate',
      key: 'lastVisitDate',
      render: (date, record) => (
        <div>
          {date ? (
            <>
              <div>{moment(date).format('DD MMM YYYY')}</div>
              <div style={{ fontSize: '12px', color: '#666' }}>{record.lastVisitOutlet || '-'}</div>
            </>
          ) : (
            <Tag color="default">No visits yet</Tag>
          )}
        </div>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status ? 'green' : 'red'}>
          {status ? 'Active' : 'Inactive'}
        </Tag>
      )
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Tooltip title="View Details">
          <Button
            type="primary"
            icon={<EyeOutlined />}
            onClick={() => handleViewDetails(record)}
            style={{ backgroundColor: '#C9262C', borderColor: '#C9262C' }}
          />
        </Tooltip>
      )
    }
  ];

  return (
    <div style={{ padding: '24px', background: '#f0f2f5', minHeight: '100vh' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '24px', fontWeight: '600', color: '#C9262C', marginBottom: '8px' }}>
            Employee Management
          </h1>
          <p style={{ color: '#666' }}>View and manage all employee members and their visit records</p>
        </div>

        {/* Statistics Cards */}
        {/* <Row gutter={16} style={{ marginBottom: '24px' }}>
          <Col span={6}>
            <Card>
              <Statistic
                title="Total Staff"
                value={stats.totalStaff}
                prefix={<TeamOutlined />}
                valueStyle={{ color: '#C9262C' }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Active Staff"
                value={stats.activeStaff}
                prefix={<CheckCircleOutlined />}
                valueStyle={{ color: '#52c41a' }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Today's Visits"
                value={stats.totalVisitsToday}
                prefix={<ClockCircleOutlined />}
                valueStyle={{ color: '#1890ff' }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Avg Visits/Staff"
                value={stats.avgVisitsPerStaff}
                suffix="visits"
                valueStyle={{ color: '#FFDD09' }}
              />
            </Card>
          </Col>
        </Row> */}

        {/* Search and Actions */}
        <Card style={{ marginBottom: '24px' }}>
          <Space style={{ width: '100%', justifyContent: 'space-between' }}>
            <Search
              placeholder="Search by name, username or mobile"
              allowClear
              enterButton={<SearchOutlined />}
              size="large"
              style={{ width: 300 }}
              onSearch={(value) => {
                setSearchText(value);
                setPagination({ ...pagination, current: 1 });
              }}
            />
            <Button
              icon={<ReloadOutlined />}
              onClick={() => {
                setSearchText('');
                setPagination({ ...pagination, current: 1 });
                fetchStaffList();
              }}
            >
              Refresh
            </Button>
          </Space>
        </Card>

        {/* Staff Table */}
        <Card>
          <Table
            columns={columns}
            dataSource={staffList}
            loading={loading}
            rowKey="_id"
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} staff members`,
              onChange: (page, pageSize) => {
                setPagination({ ...pagination, current: page, pageSize });
              }
            }}
          />
        </Card>
      </div>
    </div>
  );
}

export default StaffList;